export default "__VITE_ASSET__CiQT6ihe__"